import { callbackUrls } from "@ssf/auth-components";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App.jsx";

if (!Object.values(callbackUrls).includes(location.pathname)) {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
